module.exports = __webpack_public_path__ + "static/media/16_l_stena_0_0.734e706a.png";